import {ReactNode} from "react";
import {Modal} from "react-bootstrap";

import {FormOverlayButtons} from "./FormOverlayButtons.tsx";

interface Props {
  onCancel?: () => void;
  submitText?: string;
  cancelText?: string;
  disabled?: boolean;
  formId?: string;
  hasCancelButton?: boolean;
  hasSubmitButton?: boolean;
  leftAction?: ReactNode;
}

export const FormModalFooter = ({
  submitText,
  onCancel,
  cancelText,
  disabled,
  formId,
  hasCancelButton = true,
  hasSubmitButton = true,
  leftAction,
}: Props) => (
  <Modal.Footer>
    {leftAction && <div className="me-auto">{leftAction}</div>}
    <FormOverlayButtons
      disabled={disabled}
      form={formId}
      submitText={submitText}
      onClick={onCancel}
      cancelText={cancelText}
      hasCancelButton={hasCancelButton}
      hasSubmitButton={hasSubmitButton}
    />
  </Modal.Footer>
);
